import React from "react";

const Creator = ({ row }) => {
  return (
    <div>{row?.creator?.employeeName ? row?.creator?.employeeName : "-"}</div>
  );
};

export default Creator;
